import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getPopulateUsers } from "../../Redux/actions/accountsactions/getContractComments";
import { useSession } from "../../context/SessionContext";
// Reuses the approver dropdown styles first written for the GRN form.
import "../Operations/Vendor/GRN/AddGrn.css";

const ApproverPicker = ({ projectId, value = [], onChange }) => {
  const dispatch = useDispatch();
  const { session } = useSession();
  const users = useSelector((s) => s.getAllPopulateUsers?.data || []);
  const [open, setOpen] = useState(false);
  const [term, setTerm] = useState("");
  const ref = useRef(null);

  useEffect(() => {
    if (projectId) {
      dispatch(getPopulateUsers(projectId));
    }
  }, [dispatch, projectId]);

  useEffect(() => {
    if (!open) {
      return undefined;
    }
    const onDown = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, [open]);

  const toggle = (id) =>
    onChange(value.includes(id) ? value.filter((v) => v !== id) : [...value, id]);

  const lower = term.toLowerCase();
  const filtered = users.filter(
    (u) =>
      u?.FullName?.toLowerCase().includes(lower) ||
      u?.Email?.toLowerCase().includes(lower) ||
      u?.Id?.toLowerCase().includes(lower),
  );

  return (
    <div className="grn-approvers-container" ref={ref}>
      <div className="grn-approvers-trigger-box" onClick={() => setOpen((p) => !p)}>
        {value.length === 0 ? (
          <span style={{ color: "#94a3b8", fontSize: "13px" }}>Select approver users...</span>
        ) : (
          value.map((id) => {
            const user = [...users, { Id: session?.LoginId, FullName: session?.UserName }].find(
              (u) => u?.Id === id,
            );
            return (
              <span key={id} className="grn-approver-pill">
                <span>{user?.FullName || id}</span>
                <span
                  className="grn-approver-remove-x"
                  onClick={(e) => {
                    e.stopPropagation();
                    toggle(id);
                  }}
                >
                  &times;
                </span>
              </span>
            );
          })
        )}
      </div>

      {open && (
        <div className="grn-approver-dropdown-menu">
          <input
            type="text"
            className="grn-approver-search-input"
            placeholder="Search users by name or email..."
            value={term}
            onChange={(e) => setTerm(e.target.value)}
            onClick={(e) => e.stopPropagation()}
          />
          <div>
            {filtered.map((user) => (
              <div
                key={user.Id}
                className={`grn-approver-option-item ${value.includes(user.Id) ? "selected" : ""}`}
                onClick={() => toggle(user.Id)}
              >
                <input
                  type="checkbox"
                  checked={value.includes(user.Id)}
                  readOnly
                  style={{ margin: 0, cursor: "pointer" }}
                />
                <div>
                  <div style={{ fontWeight: 600, fontSize: "12.5px" }}>{user.FullName}</div>
                  <div style={{ fontSize: "11.5px", color: "#64748b" }}>{user.Email}</div>
                </div>
              </div>
            ))}
            {filtered.length === 0 && (
              <div style={{ padding: "10px", textAlign: "center", color: "#94a3b8" }}>
                No users found
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ApproverPicker;
